export { ConversorBytesPipe } from "./Pipes/conversor-bytes.pipe";
export { CuitPipe } from "./Pipes/cuit.pipe";
export { DniPipe } from "./Pipes/dni.pipe";
export { FiltroPipe } from "./Pipes/filtro.pipe";
export { HtmlSeguroPipe } from "./Pipes/html-seguro.pipe";
export { PatentePipe } from "./Pipes/patente.pipe";
export { SumarCampoPipe } from "./Pipes/sumar-campo.pipe";
export { UrlSeguraPipe } from "./Pipes/url-segura.pipe";